module.exports = __webpack_public_path__ + "img/quota.cabf9f86.svg";